import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Job } from '../models';
import { ApiService } from './api.service';

@Injectable()
export class JobMatchCandidatesService extends ApiService<Job> {
  constructor(http: HttpClient) {
    super(http);
    this.url = 'search/jobs/candidates/';
  }
}
